import Big from "big.js";
import { ProductV2 } from "./productv2.model";
import { AtomicProductV2 } from "./atomic-productv2.model";

export class KitProductV2 extends ProductV2 {

    device: AtomicProductV2;
    consumable: AtomicProductV2;
    allowance: number;
    ratioh4s: Big;
    ratiof4s: Big;
    ratiohf4s: Big;
}